import { render, staticRenderFns } from "./recGoldenSampleFeature.vue?vue&type=template&id=06302dca&"
import script from "./recGoldenSampleFeature.vue?vue&type=script&lang=js&"
export * from "./recGoldenSampleFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports